import { ReactNode } from 'react';

import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownFoldMenu } from 'components/Dropdown/menus/Fold/DropdownFoldMenu';

import { TakeActionDropdownSearchItemData } from './data/TakeActionDropdownData';
import { takeActionDropdownDataByLocale } from './data/takeActionDropdownDataByLocale';

type Props = {
  locale: UserLocale;
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
};

const dataBySearchItemType: Record<
  TakeActionDropdownSearchItemData['type'],
  { qaId: string; trackClickedName: string }
> = {
  volop: {
    qaId: 'nav-volop-link',
    trackClickedName: 'Take Action Header Dropdown > Volop',
  },
  event: {
    qaId: 'nav-event-link',
    trackClickedName: 'Take Action Header Dropdown > Events',
  },
  donations: {
    qaId: 'nav-donations-link',
    trackClickedName: 'Take Action Header Dropdown > Donations',
  },
  petitions: {
    qaId: 'nav-petitions-link',
    trackClickedName: 'Take Action Header Dropdown > Petitions',
  },
  loans: {
    qaId: 'nav-loans-link',
    trackClickedName: 'Take Action Header Dropdown > Loans',
  },
};

export function TakeActionDropdown({ locale, renderTrigger }: Props) {
  const { triggerText, triggerHref, search, resources } =
    takeActionDropdownDataByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText, triggerHref })}
      desktopTriggersOnHover
    >
      <DropdownFoldMenu
        left={{
          title: search.title,
          items: search.items.map((searchItem) => ({
            icon: searchItem.icon,
            title: searchItem.title,
            href: searchItem.href,
            qaId: dataBySearchItemType[searchItem.type].qaId,
            trackClickedName:
              dataBySearchItemType[searchItem.type].trackClickedName,
            fullPageRedirect: true,
          })),
        }}
        right={{
          title: resources.title,
          items: resources.items.map((resourceItem) => ({
            image: resourceItem.image,
            title: resourceItem.title,
            description: resourceItem.description,
            href: resourceItem.href,
          })),
        }}
      />
    </Dropdown>
  );
}
